import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
  helper?: string;
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  icon,
  helper,
  className = '',
  ...props
}) => {
  const inputClasses = `
    w-full py-3 border border-slate-300 rounded-lg 
    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 
    bg-white shadow-sm transition-all duration-200
    ${icon ? 'pl-12 pr-4' : 'px-4'}
    ${error ? 'border-red-300 focus:ring-red-500 focus:border-red-500' : ''}
    ${props.disabled ? 'bg-slate-50 text-slate-500 cursor-not-allowed' : ''}
    ${className}
  `.trim();

  return (
    <div className="space-y-2">
      {label && (
        <label className="block text-sm font-medium text-slate-700">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 pointer-events-none">
            {icon}
          </div>
        )}
        <input
          {...props}
          className={inputClasses}
        />
      </div>
      {helper && !error && (
        <p className="text-xs text-slate-500">{helper}</p>
      )}
      {error && (
        <p className="text-xs text-red-600">{error}</p>
      )}
    </div>
  );
};

export default Input;
